// ESM adapter for "react" module
export const getReactModuleCode = (globalReact: string): string => {
	return `const react = ${globalReact};

// Polyfill for useSyncExternalStore (React 18+)
const useSyncExternalStorePolyfill = react.useSyncExternalStore || function(subscribe, getSnapshot, getServerSnapshot) {
	const [state, setState] = react.useState(getSnapshot);

	react.useEffect(() => {
		const handleStoreChange = () => {
			setState(getSnapshot());
		};
		const unsubscribe = subscribe(handleStoreChange);
		handleStoreChange(); // Check for changes since last render
		return unsubscribe;
	}, [subscribe, getSnapshot]);

	return state;
};

export default react;
export const {
	Component,
	PureComponent,
	Fragment,
	StrictMode,
	Suspense,
	Profiler,
	createElement,
	cloneElement,
	createFactory,
	createRef,
	forwardRef,
	isValidElement,
	createContext,
	memo,
	lazy,
	Children,
	useCallback,
	useContext,
	useDebugValue,
	useEffect,
	useImperativeHandle,
	useLayoutEffect,
	useMemo,
	useReducer,
	useRef,
	useState,
	act,
	unstable_act,
	version
} = react;

export const useSyncExternalStore = useSyncExternalStorePolyfill;`
}

// ESM adapter for "react-dom" module
export const getReactDOMModuleCode = (globalReactDom: string): string => {
	// Before adding new exports, make sure that are avaiable on both Public(React18) as well as Editor(React16).
	return `
const ReactDOM = ${globalReactDom};

export default ReactDOM;
export const findDOMNode = ReactDOM.findDOMNode;
export const {
	createPortal,
	flushSync,
} = ReactDOM;
`
}

// ESM adapter for "react/jsx-runtime" module
export const getReactJsxRuntimeCode = () => {
	return `
import React from 'react';

function assignKey(props, key) {
  if (key === undefined || key === null) return props;
  return Object.assign({}, props, { key });
}

export function jsx(type, props, key) {
  const finalProps = assignKey(props, key);
  return React.createElement(type, finalProps);
}

export function jsxs(type, props, key) {
  return jsx(type, props, key);
}

export const Fragment = React.Fragment;
export default { jsx, jsxs, Fragment };
`
}

// ESM adapter for "react/jsx-dev-runtime" module
export const getReactJsxDevRuntimeCode = () => {
	return `
import React from 'react';
import { jsx } from 'react/jsx-runtime';

export function jsxDEV(type, props, key, _source, _self) {
  return jsx(type, props, key);
}

export const Fragment = React.Fragment;
export default { jsxDEV, Fragment };
`
}

// ESM adapter for "@preact/signals-react" module
export const getPreactSignalsReactModuleCode = (globalSignals: string): string => {
	return `const signals = ${globalSignals}; 

export const {
    Signal,
    batch,
    computed,
    effect,
    signal,
    untracked,
    useComputed,
    useSignal,
    useSignalEffect
} = signals;`
}
